import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar.jsx";
// import StickySocial from "./components/StickySocial.jsx";
import Footer from "./components/Footer.jsx";
import Home from "./pages/Home/Home.jsx";
import LandscapeOverlay from "./components/LandscapeOverlay.jsx";
import WhatsAppButton from "./components/WhatsAppButton.jsx";

const About = React.lazy(() => import("./pages/About/About.jsx"));
const Work = React.lazy(() => import("./pages/Work/Work.jsx"));
const Services = React.lazy(() => import("./pages/Services/Services.jsx"));
const Contact = React.lazy(() => import("./pages/Contact/Contact.jsx"));
const Insights = React.lazy(() => import("./pages/Insights/Insights.jsx"));
const InsightDetail = React.lazy(() => import("./pages/Insights/InsightDetail.jsx"));
const ThankYou = React.lazy(() => import("./pages/ThankYou/ThankYou.jsx"));
const NotFound = React.lazy(() => import("./pages/NotFound/NotFound.jsx"));
const ServiceDetailPage = React.lazy(() => import("./pages/Services/ServiceDetailPage.jsx"));
const CaseStudies = React.lazy(() => import("./pages/CaseStudies/CaseStudies.jsx"));
const CaseStudyDetail = React.lazy(() => import("./pages/CaseStudies/CaseStudyDetail.jsx"));

const PageLoader = () => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#000" }}>
    <div style={{ width: "40px", height: "40px", border: "2px solid #333", borderTopColor: "#F7E6CA", borderRadius: "50%", animation: "spin 1s linear infinite" }}>
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      {/* <LandscapeOverlay /> */}
      <Navbar />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/work" element={<Work />} />
          <Route path="/services" element={<Services />} />

          {/* Service Detail Routes */}
          <Route path="/luxury-brand-development" element={<ServiceDetailPage serviceSlug="luxury-brand-development" />} />
          <Route path="/luxury-branding-packaging" element={<ServiceDetailPage serviceSlug="luxury-branding-packaging" />} />
          <Route path="/luxury-public-relations" element={<ServiceDetailPage serviceSlug="luxury-public-relations" />} />
          <Route path="/luxury-social-media-marketing" element={<ServiceDetailPage serviceSlug="luxury-social-media-marketing" />} />
          <Route path="/luxury-campaign-shoots" element={<ServiceDetailPage serviceSlug="luxury-campaign-shoots" />} />
          <Route path="/luxury-web-development" element={<ServiceDetailPage serviceSlug="luxury-web-development" />} />

          <Route path="/concierge" element={<Contact />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/contact" element={<Navigate to="/concierge" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
      <WhatsAppButton />
      {/* <StickySocial /> */}
    </BrowserRouter>
  );
}